// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "8120a6130ab0bf272f25286f2e0e246e" + ".js";
};